import React, { useState, useEffect, forwardRef } from 'react';
import axios from 'axios';
import { styled, createTheme, ThemeProvider, useTheme } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

/*** Import all icons ****/
import InfoIcon from '@mui/icons-material/Info';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

/**** Add Modal popup */
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

/** Import table */
import {
    GridRowModes,
    DataGrid,
    GridToolbarContainer,
    GridActionsCellItem,
    GridRowEditStopReasons,
    GridToolbarExport
} from '@mui/x-data-grid';
import {
    randomCreatedDate,
    randomTraderName,
    randomId,
    randomArrayItem,
} from '@mui/x-data-grid-generator';

import { Link } from "react-router-dom";

import { makeStyles } from '@material-ui/core/styles';

// import Navbar from '../components/Navbar';
import Navbar from '../components/NewNavbar';
import { Typography } from '@mui/material';

/**** Add Sweetalert */
import Swal from 'sweetalert2'

/**** Services */
import userService from '../services/userService';

const initialRows = [
    {
        id: 1, firstname: 'Jared', lastname: 'Letto', username: 'jrd666', email: '30secondtomars@gmail.com',
        roles: [
            'user', 'admin'
        ]
    },
    { id: 2, firstname: 'Robert', lastname: 'Downey', username: 'rdj777', email: 'tony.stark@industries.com', roles: ['user'] }
]

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};


const roles = [
    'admin',
    'user',
    'superadmin'
];

function getStyles(name, user, theme) {
    return {
        fontWeight:
            user.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}

function EditToolbar(props) {
    const { setRows, setRowModesModel } = props;

    const [fullWidth, setFullWidth] = useState(true);
    const [maxWidth, setMaxWidth] = useState('sm');

    const [open, setOpen] = useState(false);

    const theme = useTheme();
    const [user, setUser] = useState([])

    const handleClick = () => {
        // alert('add data!')
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
    }

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setUser(
            typeof value === 'string' ? value.split(',') : value,
        );
    }

    return (
        <>
            <GridToolbarContainer>
                <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
                    Add record
                </Button>
                <GridToolbarExport printOptions={{ disableToolbarButton: true }} />
            </GridToolbarContainer>

            <Dialog
                fullWidth={fullWidth}
                maxWidth={maxWidth}
                open={open}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description">
                <DialogTitle>{"Form Add New User"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        This is form for add new user
                    </DialogContentText>
                    <Box component="form" sx={{
                        '& > :not(style)': { m: 1 },
                    }}
                        noValidate
                        autocomplete="off">
                        <FormControl fullWidth>
                            <TextField fullWidth id="outlined-basic" label="First Name" variant="outlined" />
                        </FormControl>
                        <FormControl fullWidth>
                            <TextField fullWidth id="outlined-basic" label="Last Name" variant="outlined" />
                        </FormControl>
                        <FormControl fullWidth>
                            <TextField fullWidth id="outlined-basic" label="Username" variant="outlined" />
                        </FormControl>
                        <FormControl fullWidth>
                            <TextField fullWidth id="outlined-basic" label="Email" variant="outlined" />
                        </FormControl>
                        <FormControl fullWidth>
                            <InputLabel id="demo-multiple-chip-label">Category</InputLabel>
                            <Select
                                labelId="demo-multiple-chip-label"
                                id="demo-multiple-chip"
                                multiple
                                value={user}
                                onChange={handleChange}
                                input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                                renderValue={(selected) => (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                        {selected.map((value) => (
                                            <Chip key={value} label={value} />
                                        ))}
                                    </Box>
                                )}
                                MenuProps={MenuProps}
                            >
                                {roles.map((name) => (
                                    <MenuItem
                                        key={name}
                                        value={name}
                                        style={getStyles(name, user, theme)}
                                    >
                                        {name}
                                    </MenuItem>
                                ))}
                            </Select>

                        </FormControl>

                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleClose}>Submit</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary
}))

const useStyles = makeStyles(theme => ({
    table: {
        minWidth: 650
    },
    root: {
        // padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: 400
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1
    },
    iconButton: {
        padding: 10
    },
    divider: {
        height: 28,
        margin: 4
    }
}))

const editData = (id) => {
    alert(`edit data ` + id)
}

const deleteData = (id) => {
    alert(`delete data ` + id)
}

const defaultTheme = createTheme({
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 28,
                },
            },
        },
    },
})

const Users = () => {

    const classes = useStyles()

    const [rows, setRows] = useState(initialRows); // using dummy data
    // const [rows, setRows] = useState([]);
    const [rowModesModel, setRowModesModel] = useState({});

    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(5);

    const handleRowEditStop = (params, event) => {
        if (params.reason === GridRowEditStopReasons.rowFocusOut) {
            event.defaultMuiPrevented = true;
        }
    };

    const handleEditClick = (id) => () => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    };

    const handleSaveClick = (id) => () => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
    };

    const handleDeleteClick = (id) => () => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                setRows(rows.filter((row) => row.id !== id));
                Swal.fire(
                    'Deleted!',
                    'Your file has been deleted.',
                    'success'
                )
            }
        })
    };

    const handleCancelClick = (id) => () => {
        setRowModesModel({
            ...rowModesModel,
            [id]: { mode: GridRowModes.View, ignoreModifications: true },
        });

        const editedRow = rows.find((row) => row.id === id);
        if (editedRow.isNew) {
            setRows(rows.filter((row) => row.id !== id));
        }
    };

    const processRowUpdate = (newRow) => {
        const updatedRow = { ...newRow, isNew: false };
        setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
        return updatedRow;
    };

    const handleRowModesModelChange = (newRowModesModel) => {
        setRowModesModel(newRowModesModel);
    };

    const columns = [
        {
            field: 'id', headerName: 'No', width: 70, headerAlign: 'center', align: 'center'
        },
        {
            field: 'firstname', headerName: 'First Name', minWidth: 200, flex: 1, headerAlign: 'center', align: 'left', editable: true
        },
        {
            field: 'lastname', headerName: 'Last Name', minWidth: 200, flex: 1, headerAlign: 'center', align: 'left', editable: true
        },
        {
            field: 'username', headerName: 'Username', minWidth: 100, flex: 1, headerAlign: 'center', align: 'left', editable: true
        },
        {
            field: 'email', headerName: 'Email', minWidth: 100, flex: 1, headerAlign: 'center', align: 'left', editable: true
        },
        {
            field: 'roles', headerName: 'Role User', minWidth: 100, flex: 1, headerAlign: 'center', align: 'center', editable: true, type: 'singleSelect', valueOptions: [
                'admin', 'user', 'superadmin'
            ]
        },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            width: 100,
            cellClassName: 'actions',
            getActions: ({ id }) => {
                const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

                if (isInEditMode) {
                    return [
                        <GridActionsCellItem
                            icon={<SaveIcon />}
                            label="Save"
                            sx={{
                                color: 'primary.main',
                            }}
                            onClick={handleSaveClick(id)}
                        />,
                        <GridActionsCellItem
                            icon={<CancelIcon />}
                            label="Cancel"
                            className="textPrimary"
                            onClick={handleCancelClick(id)}
                            color="inherit"
                        />,
                    ];
                }

                return [
                    <GridActionsCellItem
                        icon={<EditIcon />}
                        label="Edit"
                        className="textPrimary"
                        onClick={handleEditClick(id)}
                        color="inherit"
                    />,
                    <GridActionsCellItem
                        icon={<DeleteIcon />}
                        label="Delete"
                        onClick={handleDeleteClick(id)}
                        color="inherit"
                    />,
                ];
            },
        },
    ];

    useEffect(() => {
        console.log(rows);
        console.log(rows.roles)
    }, [])


    return (
        <ThemeProvider theme={defaultTheme}>
            <Box sx={{ display: 'flex' }}>
                <CssBaseline />

                <Navbar />
                <Box
                    component='main'
                    sx={{
                        backgroundColor: theme =>
                            theme.palette.mode === 'light'
                                ? theme.palette.grey[100]
                                : theme.palette.grey[900],
                        flexGrow: 1,
                        height: '100vh',
                        overflow: 'auto'
                    }}
                >
                    <Toolbar />
                    {/* <Container maxWidth='lg' sx={{ mt: 4, mb: 4 }}>
                        <h1>Dashboard page</h1>
                    </Container> */}
                    {/* <div role="presentation"> */}
                    <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 2, ml: 2, p: 1 }}>
                        {/* <Link underline="hover" color="inherit" href="/">
                                MUI
                            </Link> */}
                        <Link
                            underline="hover"
                            color="inherit"
                            to="/"
                        >
                            Home
                        </Link>
                        <Typography color="text.primary">All User List</Typography>
                    </Breadcrumbs>
                    {/* </div> */}

                    <Container maxWidth='xl' sx={{ mt: 1, mb: 3 }}>
                        {/* <Typography><h6><ChevronRightIcon />{' '}Categories</h6></Typography> */}



                        <Grid container spacing={3}>
                            {/* SECTION #1 */}
                            {/* <Grid item xs={12} md={6} lg={6}>
                                <Paper
                                    sx={{
                                        p: 1,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        // height: 240
                                    }}
                                >
                                    Content #2

                                </Paper>
                            </Grid> */}
                            <Grid item xs={12} md={12} lg={12}>
                                <Paper
                                    sx={{
                                        // p: 1, 
                                        display: 'flex',
                                        flexDirection: 'column',
                                        height: 'auto'
                                    }}
                                >
                                    {/* Content #3 */}
                                    <div style={{ height: 480, width: '100%' }}>
                                        <DataGrid
                                            rows={rows}
                                            columns={columns}
                                            editMode="row"
                                            rowModesModel={rowModesModel}
                                            onRowModesModelChange={handleRowModesModelChange}
                                            onRowEditStop={handleRowEditStop}
                                            processRowUpdate={processRowUpdate}
                                            slots={{
                                                toolbar: EditToolbar,
                                            }}
                                            slotProps={{
                                                toolbar: { setRows, setRowModesModel },
                                            }}

                                            initialState={{
                                                pagination: {
                                                    paginationModel: {
                                                        page: page,
                                                        pageSize: limit
                                                    }
                                                },
                                                columns: {
                                                    columnVisibilityModel: {
                                                        rating: false,
                                                        version: false
                                                    }
                                                }
                                            }}
                                            pageSizeOptions={[5, 10, 25, 50, 100]}
                                        />
                                    </div>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Container>
                </Box>
            </Box>
        </ThemeProvider>
    )
}

export default Users;